export default __webpack_public_path__ + "static/logo-bfff3c8c8a70bf5c0c554bec569b74e9.png";